const domain =
  process.env.NODE_ENV === "production"
    ? "https://omenofsorrow.com"
    : process.env.REACT_APP_LOCAL_IP || "http://192.168.0.1:3013";

export { domain };
